import { ApiService } from "../../../config/apiServices";
import { ADMIN_ME, ADMIN_ME_COACH, BATCH_LIST, USER_MENU, BATCH_ATHLETES, CATEGORY_LIST, AMS_VENUE, AMS_SUPERVISOR, GET_EQUIPMENT, TRAINING_LIST, POST_TRAINING, AMS_DASHBOARD_STATS, AMS_COACH_ATHLETE_STATS, AMS_COACH_ATHLETES, AMS_COACH_ATHLETES_EXPORT, AMS_ATTENDANCE_REPORT, AMS_MY_SESSIONS, AMS_ATTENDANCE_STATS, AMS_ATTENDANCE_EXPORT, AMS_TRAINING_LIST_SUMMARY, COACHES_LIST_URL } from "../../../config/adminUrlConfig";

export const getBatchList = (
  currentPage = 1,
  perPage = 10,
  payload = {}
) => {
  return ApiService.get(BATCH_LIST, {
    params: {
      page: currentPage,
      per_page: perPage,
      ...payload,
    },
  });
};

export const DeleteBatch = (id) => {
  try {
    return ApiService.delete(`${BATCH_LIST}/${id}`);
  } catch (error) {
    return error.message;
  }
}

export const UserMenu = () => {
  return ApiService.get(USER_MENU);
};

export const createBatch = (payload) => {
  return ApiService.post(`${BATCH_LIST}`, payload);
};

export const UpdateBatch = (id, payload) => {
  return ApiService.put(`${BATCH_LIST}/${id}`, payload);
};

export const getBatchById = (id, payload) => {
  return ApiService.get(`${BATCH_LIST}/${id}`, { params: payload });
}

export const getBatchAthletes = (
  payload = {}
) => {
  return ApiService.get(`${BATCH_ATHLETES}`, {
    params: payload,
  });
};

export const getCoachesList = (payload = {}) => {
  return ApiService.get(COACHES_LIST_URL, {
    params: payload,
  });
};

export const getAllCategoryList = () => {
  return ApiService.get(`${CATEGORY_LIST}`);
}

export const getAllVenueList = () => {
  return ApiService.get(`${AMS_VENUE}`);
}

export const getAllSupervisorList = () => {
  return ApiService.get(`${AMS_SUPERVISOR}`);
}

export const getEquipmentAllocationList = (payload) => {
  return ApiService.get(`${GET_EQUIPMENT}`, {
    params: payload,
  });
}

export const getTrainingsList = (payload) => {
  return ApiService.get(`${TRAINING_LIST}`, {
    params: payload,
  });
}

export const trainingDetails = (id) => {
  return ApiService.get(`${TRAINING_LIST}/${id}`);
}

export const deleteTraining = (id) => {
  return ApiService.delete(`${TRAINING_LIST}/${id}`);
}

export const createTraining = (payload) => {
  return ApiService.post(`${POST_TRAINING}`, payload);
}

export const UpdateTraining = (id, payload) => {
  return ApiService.put(`${TRAINING_LIST}/${id}`, payload);
};

export const getAcademyDashboardStats = () =>
  ApiService.get(AMS_DASHBOARD_STATS);

export const getCoachAthleteStats = (params = {}) =>
  ApiService.get(AMS_COACH_ATHLETE_STATS, { params });

export const getCoachAthletes = (coachId) =>
  ApiService.get(`${AMS_COACH_ATHLETES}/${coachId}`);

export const getCoachAthletesExport = (params = {}) =>
  ApiService.get(AMS_COACH_ATHLETES_EXPORT, { params });

export const getAdminMe = () =>
  ApiService.get(ADMIN_ME);

export const getCoachMe = () =>
  ApiService.get(ADMIN_ME_COACH);

export const getVenueLocation = (trainingId) =>
  ApiService.get(`${TRAINING_LIST}/${trainingId}/venue-location`);

export const getTrainingAttendance = (trainingId, date) =>
  ApiService.get(`${TRAINING_LIST}/${trainingId}/attendance`, { params: { date } });

export const submitTrainingAttendance = (trainingId, payload) =>
  ApiService.post(`${TRAINING_LIST}/${trainingId}/attendance`, payload);

export const getAttendanceReport = (params = {}) =>
  ApiService.get(AMS_ATTENDANCE_REPORT, { params });

export const getAttendanceDetail = (trainingId, date) =>
  ApiService.get(`${TRAINING_LIST}/${trainingId}/attendance/detail`, { params: { date } });

export const getMyTrainingSessions = () =>
  ApiService.get(AMS_MY_SESSIONS);

export const getAttendanceStats = (params = {}) =>
  ApiService.get(AMS_ATTENDANCE_STATS, { params });

export const exportAttendanceCsv = (params = {}) =>
  ApiService.get(AMS_ATTENDANCE_EXPORT, { params });

export const getTrainingListSummary = (params = {}) =>
  ApiService.get(AMS_TRAINING_LIST_SUMMARY, { params });